module.exports = __webpack_public_path__ + "5b09a916c144c10007e6f699a6ca7176.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-princess-cinderalla.svg
// module id = 475
// module chunks = 0